module.exports = __webpack_public_path__ + "img/c31.cc143cdf.png";